
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crop-webp",
      function () {
        return require("private-next-pages/crop-webp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crop-webp"])
      });
    }
  